export default __webpack_public_path__ + "static/media/cog-b-ready.8ab22170.svg";